import React, { useState, useEffect } from 'react';
import {Box, Grid, Card, CardContent, CardMedia, Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, IconButton, CircularProgress, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import NearByServices from '../services/externalServices/nearby_indexServices';
import './NearByLoc.css';

const NearbyIndexList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false); 

  useEffect(() => {
    // Fetch categories from the API
    const fetchCategories = async () => {
      try {
        const response = await NearByServices.getAllNearyIndex();
        setCategories(response);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleOpen = (category = null) => {
    setSelectedCategory(category);
    setIsEditing(Boolean(category));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCategory(null);
  };

  const handleSave = async(data) => {
    if (isEditing && selectedCategory) {
      // Logic to update the category
      try {
        const res = await NearByServices.editNearyIndex(selectedCategory._id, data); // Pass the ID and data to update
        console.log("Category updated successfully", res);
      } catch (error) {
        console.error("Error while updating the category:", error);
      }
    } else {
      // Logic to add a new category
      try{
        const res=await NearByServices.addNearyByIndex(data)
      }catch(error){
        console.log("error while adding the nearbyIndex ",error)
      }
    
      
    }
    handleClose();
  };


   // Open delete confirmation modal
   const handleDeleteOpen = (category) => {
    setSelectedCategory(category);
    setOpenDeleteConfirm(true);
  };

  // Close delete confirmation modal
  const handleDeleteClose = () => {
    setOpenDeleteConfirm(false);
    setSelectedCategory(null);
  };

  // Handle delete action
  const handleDelete = async () => {
    if (selectedCategory) {
      try {
        await NearByServices.deleteNearyIndexById(selectedCategory._id);
        setCategories(categories.filter((cat) => cat._id !== selectedCategory._id));
        console.log("Category deleted successfully");
      } catch (error) {
        console.error("Error while deleting the category:", error);
      }
      handleDeleteClose();
    }
  };

  // if (loading) return <CircularProgress sx={{justifyContent:'center',alignItems:'center'}}/>;
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh', // Full viewport height to center vertically
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (error) return <Alert severity="error">Error fetching data: {error.message}</Alert>;

  return (
    <div className='container'>
      <Typography variant="h4" gutterBottom>
        Categories List
      </Typography>
      <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => handleOpen()}>
        Add Category
      </Button>
      <Grid container spacing={3} mt={2}>
        {categories.map((category) => (
          <Grid item xs={12} sm={6} md={4} key={category._id}>
            <Card>
              <CardMedia component="img" height="140" image={category.catThumbnail} alt={category.catShortName} sx={{ width: '100px', height: '100px', objectFit: 'cover', margin: '0 auto', paddingTop: '16px' }}  />
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {category.catShortName} {category.catEmoji}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Priority: {category.catPriority}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {category.isEnabled ? 'Enabled' : 'Disabled'}
                </Typography>
              </CardContent>
              <IconButton aria-label="edit" onClick={() => handleOpen(category)}>
                <EditIcon />
              </IconButton>
              <IconButton aria-label="delete" onClick={() => handleDeleteOpen(category)}>
                <DeleteIcon color="error" />
              </IconButton>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Modal for Editing/Adding */}
      {/* Modal for Editing/Adding */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{isEditing ? 'Edit Category' : 'Add Category'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isEditing ? 'Edit the details of the category.' : 'Fill in the details for the new category.'}
          </DialogContentText>

          <TextField
            margin="dense"
            label="Category Short Name"
            fullWidth
            value={selectedCategory?.catShortName || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catShortName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Full Name"
            fullWidth
            value={selectedCategory?.catFullName || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catFullName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Description"
            fullWidth
            value={selectedCategory?.catDescription || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catDescription: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Type"
            fullWidth
            value={selectedCategory?.catType || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catType: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Icon"
            fullWidth
            value={selectedCategory?.catIcon || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catIcon: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Emoji"
            fullWidth
            value={selectedCategory?.catEmoji || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catEmoji: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Colors"
            fullWidth
            value={selectedCategory?.catColors || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catColors: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Thumbnail"
            fullWidth
            value={selectedCategory?.catThumbnail || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catThumbnail: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Category Cover Image"
            fullWidth
            value={selectedCategory?.catCoverImg || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catCoverImg: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Subcategories"
            fullWidth
            value={selectedCategory?.subCategories?.join(', ') || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, subCategories: e.target.value.split(', ') })}
          />
          <TextField
            margin="dense"
            label="Priority"
            fullWidth
            type="number"
            value={selectedCategory?.catPriority || ''}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, catPriority: parseInt(e.target.value, 10) })}
          />
          <TextField
            margin="dense"
            label="Enabled"
            fullWidth
            select
            value={selectedCategory?.isEnabled || false}
            onChange={(e) => setSelectedCategory({ ...selectedCategory, isEnabled: e.target.value === 'true' })}
            SelectProps={{
              native: true,
            }}
          >
            <option value={true}>Enabled</option>
            <option value={false}>Disabled</option>
          </TextField>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={()=>handleSave(selectedCategory)} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

        {/* Confirmation Modal for Deleting */}
        <Dialog open={openDeleteConfirm} onClose={handleDeleteClose}>
        <DialogTitle>Delete Category</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the category "{selectedCategory?.catShortName}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NearbyIndexList;
